import fp from 'lodash/fp';

import flatten from './csaDrilldownFlatten';

const createCsaRow = (csa, error, status, counterparty, rowId, type) => {
    const csaRow = {
        title: csa,
        trades: '',
        imAmountEur: '',
        imAmountConfirmedEur: '',
        imAmountIncrementEur: '',
        imTotalEur: '',
        imAmountUsd: '',
        imAmountConfirmedUsd: '',
        imAmountIncrementUsd: '',
        imTotalUsd: '',
        titleRow: true,
        error: error || '',
        id: rowId,
        status,
        counterparty,
        type
    };
    return csaRow;
};

export const mapCsaSummariesToGrid = fp.reduce((acc, cur) => (
    [
        ...acc,
        createCsaRow(cur.csa, cur.error, cur.monitorStatus, cur.counterparty, `${cur.csa}`, cur.csaType),
        {
            ...cur.pledge,
            title: 'Pledge',
            id: `${cur.csa}pledge`,
            type: cur.csaType,
            csa: cur.csa
        },
        {
            ...cur.receive,
            title: 'Receive',
            id: `${cur.csa}receive`,
            type: cur.csaType,
            csa: cur.csa
        }
    ]
), []);

export const mapCsaSummariesToGridFiltered = fp.reduce((acc, cur) => {
    switch (cur.csaType) {
        case 'IM': {
            return (
                [
                    ...acc,
                    createCsaRow(cur.csa, cur.error, cur.monitorStatus, cur.counterparty, `${cur.csa}`, cur.csaType),
                    {
                        ...cur.pledge,
                        title: 'Pledge',
                        id: `${cur.csa}pledge`,
                        type: cur.csaType,
                        filtered: true,
                        csa: cur.csa
                    }
                ]
            );
        }
        case 'Monitoring': {
            return (
                [
                    ...acc,
                    createCsaRow(cur.csa, cur.error, cur.monitorStatus, cur.counterparty, `${cur.csa}`, cur.csaType),
                    {
                        ...cur.receive,
                        title: 'Receive',
                        id: `${cur.csa}receive`,
                        type: cur.csaType,
                        filtered: true,
                        csa: cur.csa
                    }
                ]
            );
        }
        default: {
            return (
                [
                    ...acc,
                    createCsaRow(cur.csa, cur.error, cur.monitorStatus, cur.counterparty, `${cur.csa}`, cur.csaType),
                    {
                        ...cur.pledge,
                        title: 'Pledge',
                        id: `${cur.csa}pledge`,
                        type: cur.csaType,
                        csa: cur.csa
                    },
                    {
                        ...cur.receive,
                        title: 'Receive',
                        id: `${cur.csa}receive`,
                        type: cur.csaType,
                        csa: cur.csa
                    }
                ]
            );
        }
    }
}, []);

export const transformIds = (csa, drilldowns) => drilldowns.map(dr => ({
    ...dr,
    id: `${csa}_${dr.id}`,
    parentId: dr.parentId && `${csa}_${dr.parentId}`,
    children: dr.children && dr.children.map(child => `${csa}_${child}`)
}));

export const mapCsaDrilldownsToGrid = (summaries) => {
    let rowId = 0;
    let imDrilldownRows = [];
    summaries.forEach((summary) => {
        const csaRow = {
            imModel: summary.csa,
            silo: '',
            riskClass: '',
            senstivity: '',
            bucket: '',
            trades: '',
            imPledgeUsd: '',
            imReceiveUsd: '',
            imPledgeEur: '',
            imReceiveEur: '',
            titleRow: true,
            id: rowId
        };
        imDrilldownRows.push(csaRow);
        rowId += 1;
        imDrilldownRows = imDrilldownRows.concat(
            transformIds(summary.csa, flatten(summary.csaDrilldowns || []))
        );
    });
    return imDrilldownRows;
};

export const filterSummaries = wholeResponse => ({
    ...wholeResponse,
    csaSummaries: wholeResponse.csaSummaries,
    csaDrilldowns: mapCsaDrilldownsToGrid(wholeResponse.csaSummaries)
});
